import fallbackAiCoach from "./fallback-ai-coach.webp"
import fallbackDiversityInclusion from "./fallback-diversity-inclusion.webp"
import fallbackEmployeeEngagement from "./fallback-employee-engagement.webp"
import fallbackEmployeeExperience from "./fallback-employee-experience.webp"
import fallbackGeneral from "./fallback-general.webp"
import fallbackLearningDevelopment from "./fallback-learning-development.webp"
import fallbackPerformanceManagement from "./fallback-performance-management.webp"
import fallbackScience from "./fallback-science.webp"

export const FALLBACK_IMAGES: Record<string, string> = {
  "ai coach": fallbackAiCoach,
  "diversity & inclusion": fallbackDiversityInclusion,
  "employee engagement": fallbackEmployeeEngagement,
  "employee experience": fallbackEmployeeExperience,
  general: fallbackGeneral,
  "learning & development": fallbackLearningDevelopment,
  "performance management": fallbackPerformanceManagement,
  science: fallbackScience,
}
